const routes = [
    {
        path: "/glossary",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'glossary_index'
        }
    }
];

export default routes;
